export function renderSkeletonGrid() {
    let skeletonItems = '';

    for (let index = 0; index < 6; index += 1) {
        skeletonItems += `
            <li class="dashboard-game-card dashboard-game-card-skeleton dashboard-skeleton-card ui-card-surface">
                <div class="dashboard-game-cover dashboard-skeleton-cover dashboard-skeleton ui-card-cover ui-card-cover--portrait"></div>
                <div class="ui-card-body dashboard-game-card-body">
                    <div class="dashboard-skeleton-title dashboard-skeleton"></div>
                </div>
            </li>
        `;
    }

    return `<ul class="dashboard-games-grid dashboard-skeleton-grid ui-game-grid" data-dashboard-skeleton aria-hidden="true">${skeletonItems}</ul>`;
}

export function renderError(sectionContent) {
    sectionContent.innerHTML = '<p class="dashboard-section-error">Section is temporarily unavailable.</p>';
    sectionContent.setAttribute('aria-busy', 'false');
}
